import { render, staticRenderFns } from "./SearchTopicList.vue?vue&type=template&id=c1ba7c64&scoped=true"
import script from "./SearchTopicList.vue?vue&type=script&lang=js"
export * from "./SearchTopicList.vue?vue&type=script&lang=js"
import style0 from "./SearchTopicList.vue?vue&type=style&index=0&id=c1ba7c64&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1ba7c64",
  null
  
)

export default component.exports